<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-12">
                        <div
                            v-if="datos.cumplimiento==null"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h3 v-else>
                           {{datos.cumplimiento}} %
                        </h3>
                        <h6 class="card-subtitle">Cumplimiento de mis cursos asignados</h6>
                    </div>
                    <div class="col-12">
                        <div class="progress">
                            <div
                                id="porcentaje_cumplimiento"
                                class="progress-bar bg-success"
                                role="progressbar"
                                :aria-valuenow="datos.cumplimiento" aria-valuemin="0"
                                aria-valuemax="100" />
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row justify-content-center pointerCursor" v-on:click="$router.push({name:'Consultar_Plan_Capacitacion', params:{location:'pendientes'}})">
                    <div class="col-auto text-center pt-3">
                        <h2>
                            <i class="fas fa-lg fa-laptop"></i>
                        </h2>
                    </div>
                    <div class="col-6 text-center pt-3">
                        <h5
                        class="card-subtitle"
                        style="cursor:pointer;">Mis Cursos Pendientes</h5>
                    </div>
                    <div class="col-auto text-center pt-2">
                        <div
                            v-if="datos.cursos_pendientes==null"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h1 v-else>{{datos.cursos_pendientes}}</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row justify-content-center pointerCursor" v-on:click="$router.push({name:'Consultar_Plan_Capacitacion', params:{location:'completados'}})">
                    <div class="col-auto text-center pt-3">
                        <h2>
                            <i class="fas fa-clipboard-check"></i>
                        </h2>
                    </div>
                    <div class="col-6 text-center pt-3">
                        <h5 class="card-subtitle">Cursos Terminados</h5>
                    </div>
                    <div class="col-auto text-center pt-2">
                        <div
                            v-if="datos.cursos_terminados==null"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h1 v-else>{{datos.cursos_terminados}}</h1>
                    </div>
                </div>
            </div>
        </div>

        <div class="card">
            <div class="card-body">
                <div class="row justify-content-center">
                    <div class="col-auto text-center pt-3">
                        <h2>
                            <i class="fas fa-trophy"></i>
                        </h2>
                    </div>
                    <div class="col-auto text-center pt-4">
                        <h5 class="card-subtitle">Mi Ranking</h5>
                    </div>
                    <div class="col-auto text-center pt-2">
                        <div
                            v-if="datos.mi_ranking==null"
                            class="d-flex justify-content-center">
                            <div class="spinner-border" role="status">
                              <span class="sr-only">Loading...</span>
                            </div>
                        </div>
                        <h1>{{datos.mi_ranking}}</h1>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

import {mapActions} from 'vuex';

export default {
    data(){
        return {
            datos:{
                mi_ranking: null,
                cursos_pendientes: null,
                cursos_terminados:null,
                cumplimiento: null
            }
        }
    },
    methods:{
        Consultar(){
            var that = this;
            this.$http.get('dashboard/cards')
            .then(respuesta=>{return respuesta.json()})
            .then(respuestaJson=>{
                this.datos = respuestaJson;
                console.log(this.datos);
                $(document).ready(function(){
                    $('#porcentaje_cumplimiento').width(that.datos.cumplimiento+'%');
                })
            })
            .catch(error=>{
                this.datos={
                    mi_ranking: '',
                    cursos_pendientes: 0,
                    cursos_terminados:0,
                    cumplimiento: 0
                }
            });
        }
    },
    mounted(){
        this.Consultar();
    }
};
</script>

<style scoped>
.pointerCursor{
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/AppLms/Dashboard/Vistas_Por_Perfil/Participante.vue